import { __awaiter, __generator } from "tslib";
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Auth } from 'aws-amplify';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth/lib/types';
var CognitoService = /** @class */ (function () {
    function CognitoService() {
    }
    CognitoService.signIn = function (email, password) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Auth.signIn(email, password)];
                    case 1:
                        response = _a.sent();
                        localStorage.setItem('a6y_provider', 'cognito');
                        localStorage.setItem('a6y_token', '');
                        localStorage.setItem('a6y_token_exp', '');
                        return [2 /*return*/, response];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, error_1];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CognitoService.signUp = function (email, password) {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Auth.signUp(email, password)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/, error_2];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CognitoService.confirmSignUp = function (email, code) {
        return __awaiter(this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Auth.confirmSignUp(email, code)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_3 = _a.sent();
                        return [2 /*return*/, error_3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CognitoService.socialLogin = function (provider, data) {
        return __awaiter(this, void 0, void 0, function () {
            var theProvider, response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        theProvider = null;
                        switch (provider) {
                            case 'facebook':
                                theProvider = CognitoHostedUIIdentityProvider.Facebook;
                                break;
                            case 'google':
                                theProvider = CognitoHostedUIIdentityProvider.Google;
                                break;
                        }
                        if (!theProvider) {
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, Auth.federatedSignIn({ provider: theProvider })];
                    case 1:
                        response = _a.sent();
                        localStorage.setItem('a6y_provider', data.provider);
                        localStorage.setItem('a6y_token', data.token);
                        localStorage.setItem('a6y_token_exp', data.expiresAt);
                        return [2 /*return*/, response];
                    case 2:
                        error_4 = _a.sent();
                        return [2 /*return*/, error_4];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CognitoService.forgotPasswordSubmit = function (user, code, password) {
        return __awaiter(this, void 0, void 0, function () {
            var error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Auth.forgotPasswordSubmit(user, code, password)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_5 = _a.sent();
                        return [2 /*return*/, error_5];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CognitoService.forgotPassword = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            var error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Auth.forgotPassword(email)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_6 = _a.sent();
                        return [2 /*return*/, error_6];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CognitoService.signOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._signOutCognito()];
                    case 1:
                        _a.sent();
                        this._signOutFacebook();
                        this._signOutGoogle();
                        localStorage.removeItem('a6y_provider');
                        localStorage.removeItem('a6y_token');
                        localStorage.removeItem('a6y_token_exp');
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.log('catch: ', e_1); // eslint-disable-line no-console
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CognitoService._signOutCognito = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Auth.signOut()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CognitoService._signOutFacebook = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (!(localStorage.getItem('atc_provider') === 'facebook')) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.waitForFb()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, window.FB.logout()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        e_2 = _a.sent();
                        console.log('LOGOUT FB error', e_2); // eslint-disable-line no-console
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CognitoService._signOutGoogle = function () {
        return __awaiter(this, void 0, void 0, function () {
            var auth2, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.waitForGapi()];
                    case 1:
                        _a.sent();
                        if (!window.gapi.auth2) return [3 /*break*/, 3];
                        auth2 = window.gapi.auth2.getAuthInstance();
                        return [4 /*yield*/, auth2.signOut()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        e_3 = _a.sent();
                        console.log('LOGOUT G error', e_3); // eslint-disable-line no-console
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CognitoService.waitForGapi = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var waited = 0;
                        function wait(interval) {
                            setTimeout(function () {
                                waited += interval;
                                if (window.gapi !== undefined) {
                                    return resolve();
                                }
                                if (waited >= 20 * 1000) {
                                    return reject({ message: 'Timeout' });
                                }
                                wait(interval * 2);
                            }, interval);
                        }
                        wait(30);
                    })];
            });
        });
    };
    CognitoService.waitForFb = function () {
        return new Promise(function (resolve, reject) {
            var waited = 0;
            function wait(interval) {
                setTimeout(function () {
                    waited += interval;
                    if (window.FB && window.FB !== undefined) {
                        return resolve();
                    }
                    if (waited >= 20 * 1000) {
                        return reject({ message: 'Timeout' });
                    }
                    wait(interval * 2);
                }, interval);
            }
            wait(30);
        });
    };
    return CognitoService;
}());
export default CognitoService;
//# sourceMappingURL=CognitoService.js.map